module.exports = __webpack_public_path__ + "static/media/facebook.b3346fe5.svg";